import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-ink text-bone" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <p className="text-[11px] uppercase tracking-[0.3em] text-bone/50 mb-6">— Since 2016</p>
          <h3 className="font-serif text-4xl md:text-6xl leading-[0.98] text-bone">
            Let's design the next<br /><span className="italic text-clayLight">moment</span> together.
          </h3>
          <Link to="/contact" data-testid="footer-cta" className="editorial-link inline-block mt-8 text-[13px] uppercase tracking-[0.22em] text-bone">
            Start a project →
          </Link>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-bone/50 mb-4">Studio</p>
          <p className="text-bone/85 leading-relaxed">
            Muse n Aura Designs<br />
            13, 4th Main Road, Indiranagar 2nd Stage<br />
            Bangalore · India
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-bone/50 mb-4">Contact</p>
          <p className="text-bone/85 leading-relaxed">
            studio@musenaura.com<br />
            +91 63663 02902
          </p>
          <div className="flex gap-5 mt-6 text-[12px] uppercase tracking-[0.22em]">
            <a href="https://www.instagram.com/musenaura.designs/" target="_blank" rel="noopener noreferrer" className="editorial-link">Instagram</a>
            <a href="https://www.linkedin.com/company/indesignverse/" target="_blank" rel="noopener noreferrer" className="editorial-link">LinkedIn</a>
          </div>
        </div>
      </div>
      <div className="border-t border-bone/12">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.22em] text-bone/45">
          <p>© {new Date().getFullYear()} Muse n Aura Designs. All rights reserved.</p>
          <p>We design moments.</p>
        </div>
      </div>
    </footer>
  );
}
